import React, { useState, useRef } from 'react';
import Layout from "../../component/layout/Layout";
import 'aos/dist/aos.css';
import Swal from 'sweetalert2';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import firebaseConfig from '../firebase/firebaseConfig';
import "./ContactPage.css";

// Initialize Firebase only if not already initialized
if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
}

const ContactPage = () => {
    const [formData, setFormData] = useState({
        name: '',
        mobile: '',
        email: '',
        cname: '',
        country: '',
        subject: '',
        message: '',
    });

    const iframeRef = useRef(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(formData.email)) {
            Swal.fire({
                icon: 'error',
                title: 'Invalid Email',
                text: 'Please enter a valid email address.'
            });
            return;
        }

        Swal.fire({
            title: 'Sending...',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            // 1. Save to Firestore
            await firebase.firestore().collection("mainContactform").add({
                ...formData,
                submittedAt: new Date()
            });

            // 2. Build subject
            const customSubject = `New Main Contact Message from RMC Website ${formData.name}`;
            const formWithSubject = { ...formData, subject: customSubject };

            // 3. Encode to query string
            const query = Object.entries(formWithSubject)
                .map(([key, val]) => `${encodeURIComponent(key)}=${encodeURIComponent(val)}`)
                .join("&");

            // 4. Base64 encode
            const encoded = btoa(query);

            // 5. Trigger iframe
            const mailURL = `https://api.codetabs.com/v1/proxy/?quest=http://203.115.112.59/erp/Sendmail/SendMailRMCWebsite.aspx?data=${encoded}`;
            iframeRef.current.src = mailURL;

            Swal.fire({
                icon: 'success',
                title: 'Message Sent!',
                text: 'Thank you for contacting us. We will get back to you shortly.'
            });

            // 6. Reset form
            setFormData({
                name: '',
                mobile: '',
                email: '',
                cname: '',
                country: '',
                subject: '',
                message: ''
            });

        } catch (error) {
            console.error('Error:', error);
            Swal.fire({
                icon: 'error',
                title: 'Oops!',
                text: 'Something went wrong. Please try again later.'
            });
        }
    };

    const [activeSlide, setActiveSlide] = useState(0);

    const handleSlideChange = (index) => {
        setActiveSlide(index);
    };

    return (
        <Layout>
            <section id="hero">
                <div id="heroCarousel" className="carousel slide carousel-fade" data-bs-interval="5000" data-bs-ride="carousel">
                    <ol className="carousel-indicators" id="hero-carousel-indicators">
                        <li
                            data-bs-target="#heroCarousel"
                            data-bs-slide-to="0"
                            className={activeSlide === 0 ? "active" : ""}
                            onClick={() => handleSlideChange(0)}
                        ></li>
                    </ol>
                    <div className="carousel-inner" role="listbox">
                        <div className={`carousel-item ${activeSlide === 0 ? "active" : ""}`} style={{ backgroundImage: "url(/img/map1.webp)" }}>
                            <div className="carousel-container">
                                <div className="container">
                                    <div className="text" id='text'>
                                        <h2 className="animate__animated animate__fadeInDown" data-aos="fade-down">Contact & Sales</h2>
                                        <p className="animate__animated animate__fadeInUp" data-aos="fade-up">
                                            Products manufactured by Rishabh are exported regularly to various countries in Europe, Americas, Africa, Middle East and Asia.
                                            If you would like to receive our products write to us at our mail address or use our contact form to contact us and we’ll help you in any way we can help.
                                            Thank you.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* contact form */}
            <section id="contact" className="contact section-bg" style={{ backgroundColor: '#e8f2fe' }}>
                <div className="container" data-aos="fade-up">
                    <div className="section-title text-center">
                        <h1 style={{ textTransform: 'capitalize' }}>Contact Us</h1>
                        <h3 className='sechead'>Please fill in and submit the form below and we’ll get back to you in one working day.</h3>
                    </div>
                    <div className="row">
                        <div className="col-lg-6 pt-5 pb-5">
                            <form onSubmit={handleSubmit} className="emailform" name="contactform">
                                <div className="form-group mt-2">
                                    <input type="text" name="name" value={formData.name} onChange={handleChange} className="form-control" id="name" placeholder='Full Name' required />
                                </div>
                                <div className="form-group mt-2">
                                    <input type="number" className="form-control" name="mobile" value={formData.mobile} onChange={handleChange} id="mobile" placeholder='Phone Number' required />
                                </div>
                                <div className="form-group mt-2">
                                    <input type="email" className="form-control" name="email" value={formData.email} onChange={handleChange} id="email" placeholder='Email' required />
                                </div>
                                <div className="form-group mt-2">
                                    <input type="text" className="form-control" id="cname" name="cname" value={formData.cname} onChange={handleChange} placeholder="Company name" />
                                </div>
                                <div className="form-group mt-2">
                                    <input type="text" className="form-control" id="country" name="country" value={formData.country} onChange={handleChange} placeholder="Country" />
                                </div>
                                <div className="form-group mt-2">
                                    <input type="text" className="form-control" id="subject" name="subject" value={formData.subject} onChange={handleChange} placeholder="Subject" />
                                </div>
                                <div className="form-group mt-2">
                                    <textarea className="form-control" id="message" name="message" value={formData.message} onChange={handleChange} placeholder="Message" rows="4" required />
                                </div>
                                <input type="submit" className="text-center mt-3 button" name="submit" id="submit" />
                            </form>
                        </div>
                        <div className="col-lg-6">
                            <div className="row">
                                <div className="col">
                                    <div className="info mt-4">
                                        <iframe
                                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3774.3800180258067!2d72.81794409999999!3d18.9145662!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7d19150a5fa6d%3A0xbc1b9593f23dad07!2sWorld%20Trade%20Center%20Mumbai!5e0!3m2!1sen!2sin!4v1742031842325!5m2!1sen!2sin"
                                            width="100%"
                                            height="480"
                                            style={{ border: 0 }}
                                            allowFullScreen=""
                                            loading="lazy"
                                            referrerPolicy="no-referrer-when-downgrade"
                                        ></iframe>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Hidden Iframe for email trigger */}
            <iframe
                ref={iframeRef}
                title="Mail Submission"
                style={{ display: "none" }}
            ></iframe>
        </Layout>
    );
};

export default ContactPage;
